import axios from 'axios';

const KruozAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

KruozAPI.interceptors.request.use(config => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    config.headers['X-Company-Id'] = user.companyId;
    config.headers['Authorization'] = `Bearer ${user.token}`;
  }
  return config;
});

KruozAPI.interceptors.response.use(
  response => response,
  error => {
    // Handle errors globally, e.g., show a toast notification
    console.error(error);
    return Promise.reject(error);
  }
);

export default KruozAPI;